import React from 'react';
import { Link } from 'react-router';
import './home.css';

import services from '../data/services';

const Home = () => {
  return (
    <>
    <section className="top-section home">
      <div className="overlay">
        <div className="column">
          <h1 style={{color: "var(--color-2)"}}>Crafting Solutions to<br/>Power Industries</h1>
          <p>
            <span>
              At Renew Engineering we are committed to your company's success. Our goal is to ensure your design is safe, reliable, and time saving. Consider us for your next design, automation, or machining needs
            </span>
          </p>
          <div>
            <Link to="/projects" className="btn-primary">
              See Our Projects
            </Link>
          </div>
        </div>
      </div>
    </section>
    <section className="home-section-2">
      <div className="overlay">
        <div className="column">
          <div className="column-2">
            <img src="/images/home/machining-icon.png"/> 
            <h4>Machining Services</h4>
          </div>
          <div className="column-2">
            <img src="/images/home/consulting-icon.png"/> 
            <h4>Consulting and Designing</h4>
          </div>
          <div className="column-2">
            <img src="/images/home/automation-icon.png"/> 
            <h4>Production Automation</h4>
          </div>
        </div>
      </div>
    </section>
    <section className="home-section-3">
      <div className="column col-1">
        <img src="/images/home/welder.gif"/>
        <div className="experience-box">
          <h1>30+</h1>
          <p>Years of<br/>experience</p>
        </div>
      </div>
      <div className="column col-2">
        <h2>
          Better Tools<br/>
          Safer Workplaces<br/>
          Brighter Future<br/>
        </h2>
        <p>
          We prioritize safety as we design and implement solutions that drive your business forward. With 30+ years of experience we are well versed in safe measures and industry standards.
        </p>
      </div>
    </section>
    <section className="home-section-4">
      <div className="image-container-1">
        <div className="image">
        </div>
      </div>
      <div className="image-container-2">
        <div className="image">
        </div>
      </div>
      <div className="recent-projects">
        <h2>Recent Projects</h2>
        <p>
          Every project comes with its own needs and challenges. Tell us your priorities, and we'll fill them to your satisfaction.
        </p>
        <Link to="/projects" className="btn-secondary hollow">
          See Projects
        </Link>
      </div>
      <div className="image-container-3">
        <div className="image">
        </div>
      </div>

    </section>
    <section className="home-section-5">
      <p>SERVICES</p>
      <h2>How we can help you!</h2>

    </section>
    <section className="home-section-6">
      <div className="services-container">

        {services.map((service) => (
          <div key={service.id} className="card">
            <div className="image">
              <img src={service.icon}/>
            </div>
            <div className="text">
              <h3>{service.title}</h3>
              <p dangerouslySetInnerHTML={{__html: service.text}}></p>
            </div>
            <div className="button">
              <Link to={`/services#${service.sid}`} className="btn-primary">
                Read More
              </Link>
            </div>
          </div>
        ))}
    
      </div>
    </section>
    
    </>
  )
}

export default Home